import React, { useState } from 'react';

import { InvitePartner } from './InvitePartner';
import { PartnerList } from './PartnerList';
import { InvitePartnerFormProps } from '../../InterstitialModal.types';

export const InvitePartnerForm = ({ invites, refetch }: InvitePartnerFormProps) => {
  const [invitePartner, setInvitePartner] = useState<boolean>(false);

  return (
    <>
      <PartnerList invites={invites} onAddPartner={() => setInvitePartner(true)} />
      {invitePartner && (
        <InvitePartner
          onDone={() => {
            setInvitePartner(false);
            refetch();
          }}
        />
      )}
    </>
  );
};
